const rows = [
  {
    company: "Adfolks",
    what: "Founded and scaled into a top Microsoft Azure partner in the Middle East.",
    outcome: "Acquired · ZainTech (Zain Group) · 2023",
  },
  {
    company: "Actualize",
    what: "Voice agents that speak Arabic the way people in the GCC actually speak it.",
    outcome: "Acquired · CNTXT Tech",
  },
  {
    company: "AppsIntegra",
    what: "Enterprise datacenter and cloud automation.",
    outcome: "Exited",
  },
];

const TrackRecord = () => {
  return (
    <section className="py-32 px-4 bg-secondary border-y-4 border-foreground">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-16 space-y-6">
          <div className="inline-block px-6 py-3 bg-primary/10 border-2 border-primary/20 rounded">
            <span className="text-sm font-bold tracking-[0.3em] text-primary uppercase">Track Record</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-foreground">
            We've been on your side of the table
          </h2>
        </div>

        <div className="space-y-6">
          {rows.map((row, i) => (
            <div
              key={row.company}
              className={`p-8 bg-background border-l-4 ${i % 2 === 0 ? "border-accent" : "border-primary"} grid md:grid-cols-12 gap-4 items-center hover:shadow-lg transition-shadow`}
            >
              <div className="md:col-span-3">
                <p className="text-2xl font-black text-foreground">{row.company}</p>
              </div>
              <div className="md:col-span-6">
                <p className="text-base text-foreground leading-relaxed">{row.what}</p>
              </div>
              <div className="md:col-span-3">
                <p className="text-sm font-bold uppercase tracking-wider text-accent">{row.outcome}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;